import React, { useRef } from 'react';

import useOutsideClick from '../../../hooks/useOutsideClicks';
import { CloseIcon } from '../../../assets';
import { BookedLeadsListModalProps } from '../models/calendarModels';

const BookedLeadsListModal: React.FC<BookedLeadsListModalProps> = ({
  onClose,
  matchedEvents,
}) => {
  const showEditModalRef = useRef<HTMLDivElement>(null);
  useOutsideClick(showEditModalRef, () => onClose());

  return (
    <div className="booked-leads-modal__overlay">
      <div className="booked-leads-modal__container" ref={showEditModalRef}>
        <div className="booked-leads-modal__header">
          <h2 className="booked-leads-modal__title">Scheduled Events</h2>
          <div className="booked-leads-modal__close-button" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="booked-leads-modal__events-wrapper">
          {matchedEvents &&
            matchedEvents.map((event, index) => (
              <div className="booked-leads-modal__event-card" key={index}>
                <div className="booked-leads-modal__event-header">
                  <h3 className="booked-leads-modal__event-title">
                    {event.event.title}
                  </h3>
                  <p className="booked-leads-modal__event-time">
                    {new Date(event.timing.start).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                    })}{' '}
                    -{' '}
                    {new Date(event.timing.end).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </p>
                </div>

                <div className="booked-leads-modal__event-details">
                  <p>
                    <strong>Organizer:</strong>{' '}
                    {event.participants.organizer.name} (
                    {event.participants.organizer.email})
                  </p>

                  <p>
                    <strong>Guests:</strong>{' '}
                    {event.participants.guests.length > 0
                      ? event.participants.guests.map((guest, i) => (
                          <span key={i}>{guest.email}</span>
                        ))
                      : 'None'}
                  </p>

                  <div className="booked-leads-modal__invitees">
                    <strong>Invitees:</strong>
                    <table className="booked-leads-modal__table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {event.participants.invitees.map((invitee, idx) => (
                          <tr key={idx}>
                            <td>{invitee.name}</td>
                            <td>{invitee.email}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="booked-leads-modal__bottom">
          <button className="btn-agent-bio-save w-6rem" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookedLeadsListModal;
